import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MButton } from '@/components/ui/atoms/MButtons';
import styles from './RegistrationSuccess.module.css';
import MaatraLogo from '@/components/ui/atoms/MaatraLogo';

const RegistrationSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { firstName, trialEndDate, planType = 'trial', inviterName, isJoiningFamily, isLogin } = location.state || {};

  
  const handleLetsGo = () => {
    navigate('/dashboard');
  };

  const isTrial = planType === 'trial';
  const isMonthly = planType === 'monthly';
  const isAnnual = planType === 'annual';

  const formatTrialEndDate = (dateString: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month} ${day} ${year}`;
  };

  return (
    <div className={styles.pageContainer}>
     <div className="absolute top-[-350px] left-[-135px] right-0 w-[684px] h-[684px] bg-[linear-gradient(180deg,rgba(90,65,153,0)_14.91%,rgba(149,108,255,0.2)_103.03%)] rounded-full"></div>   
      <div className={styles.content}>
        <div className={styles.logoContainer}>
          <MaatraLogo fill='#fff' size={38}/>
          
        </div>

        <h1 className={styles.title}>
          {isLogin
            ? (
              <>
                Welcome back,<br />{firstName || ''}
              </>
            )
            : isJoiningFamily 
              ? t('auth.registrationSuccess.joinFamilyTitle', { name: firstName || '' })
              : t('auth.registrationSuccess.title', { name: firstName || '' })
          }
        </h1>

        <p className={styles.description}>
          {isLogin
            ? "You're logged in to Maatra"
            : isJoiningFamily
              ? t('auth.registrationSuccess.joinFamilyDescription', { 
                  inviterName: inviterName?.split(' ')[0] || '' 
                })
              : t('auth.registrationSuccess.description')
          }
        </p>

        {!isLogin && !isJoiningFamily && isTrial && trialEndDate && (
          <p className={styles.trialInfo}>
            {t('auth.registrationSuccess.trialInfo', { date: formatTrialEndDate(trialEndDate) })}
          </p>
        )}
        
        {!isLogin && !isJoiningFamily && (isMonthly || isAnnual) && (
          <p className={styles.trialInfo}>
            {t('auth.registrationSuccess.subscriptionActive', { 
              planType: isMonthly ? 'monthly' : 'annual' 
            })}
          </p>
        )}
      </div>

      <div className={styles.footer} style={{ top: '-100px' }}>
        <MButton
          text={t('auth.registrationSuccess.letsGo')}
          size="lg"
          onClick={handleLetsGo}
        />
      </div>
    </div>
  );
};

export default RegistrationSuccess;
